module.exports = __webpack_public_path__ + "static/media/built-interior-ltd.b364b400.png";